module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/123assets/fonts/fa2aa3a96b9e3c4238ec05f5f97d17f1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = 749
// module chunks = 4